import React from "react";
import { Recommendations } from "../../components/recommendations";

function CuratedExperiences() {
  return (
    <section id="experiences" aria-label="Curated experiences">
      <div className="bg-black w-full text-center px-[14px] overflow-hidden relative h-[944px] md:h-[1106px] -z-20">
        <div
          className="w-[1px] h-12 bg-white absolute top-0 left-1/2 -translate-x-1/2"
          aria-hidden="true"
        />
        <h2 className="font-ppacma text-[56px] md:text-8xl leading-[90%] mt-[77px] max-w-[362px] text-center mx-auto md:max-w-[652px]">
          <span className="text-white">Curated Experiences,</span>
          <br />
          <span className="text-yellow">Made for You</span>
        </h2>

        <p className="text-white text-[18px] font-normal leading-[120%] tracking-[0px] text-center mt-[24px] max-w-[342px] mx-auto md:max-w-[440px] mb-7">
          League Life connects you to experiences and recommendations crafted
          for families on the move. From wellness and dining to local activities
          and lifestyle moments, our platform highlights trusted, thoughtfully
          selected options so you can explore with confidence.
        </p>
        <picture className="absolute bottom-0 right-0 left-0 mx-auto">
          <source
            media="(min-width: 1024px)"
            srcSet="/curated-experiences/booking-app-desktop.png"
          />
          <img
            src="/curated-experiences/booking-app-mobile.png"
            alt="League Life app showcasing curated experiences and personalized recommendations"
            className="object-contain mx-auto md:w-[497px] max-w-[350px] lg:max-w-none"
            loading="lazy"
            width="350"
            height="auto"
          />
        </picture>
        <img
          src="/curated-experiences/floating-image.png"
          alt=""
          className="absolute top-10 left-10 w-[221px] h-[221px] -z-10 hidden lg:block lg:opacity-50 xl:opacity-100"
          loading="lazy"
          aria-hidden="true"
        />
        <img
          src="/curated-experiences/floating-image-2.png"
          alt=""
          className="absolute top-10 right-10 w-[202px] h-[202px] -z-10 hidden lg:block lg:opacity-50 xl:opacity-100"
          loading="lazy"
          aria-hidden="true"
        />
        <img
          src="/curated-experiences/floating-image-3.png"
          alt=""
          className="absolute top-36 right-36 w-[253.6px] h-[253.6px] -z-10 hidden lg:block lg:opacity-50 xl:opacity-100"
          loading="lazy"
          aria-hidden="true"
        />
        <img
          src="/curated-experiences/floating-image-5.png"
          alt=""
          className="absolute bottom-20 left-20 w-[203.31px] h-[203.31px] -z-10 hidden lg:block lg:opacity-50 xl:opacity-100"
          loading="lazy"
          aria-hidden="true"
        />
        <img
          src="/curated-experiences/floating-image-4.png"
          alt=""
          className="absolute bottom-56 left-32 w-[311.91px] h-[311.91px] -z-10 hidden lg:block lg:opacity-50 xl:opacity-100"
          loading="lazy"
          aria-hidden="true"
        />
        <img
          src="/curated-experiences/floating-image-6.png"
          alt=""
          className="absolute bottom-20 right-20 w-[189.30px] h-[189.30px] -z-10 hidden lg:block lg:opacity-50 xl:opacity-100"
          loading="lazy"
          aria-hidden="true"
        />
      </div>
      <Recommendations />
    </section>
  );
}

export { CuratedExperiences };
